export default "__VITE_ASSET__bG6GiKuL__"